import script from "./HeaderNavLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNavLinks.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNavLinks.vue?vue&type=style&index=0&id=005a594a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005a594a"]])

export default __exports__